import React from "react";
import styled from "styled-components";

const size = 20;
const strokeWidth = 4;

const CircleWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: ${size}px;
  height: ${size}px;
`;

const CircleSVG = styled.svg`
  transform: rotate(-90deg);
`;

const CircleBackground = styled.circle`
  fill: none;
  stroke: ${({ theme }) => theme.colors.card};
  stroke-width: ${strokeWidth};
`;

const CircleProgress = styled.circle`
  fill: none;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-width: ${strokeWidth};
  stroke-linecap: round;
  stroke-dasharray: ${2 * Math.PI * (size / 2 - strokeWidth / 2)};
  stroke-dashoffset: ${(props) =>
    (1 - props.progress / 100) * 2 * Math.PI * (size / 2 - strokeWidth / 2)};
  transition: stroke-dashoffset 0.5s ease;
`;



const CircularProgress = ({ progress }) => {
  return (
    <CircleWrapper>
      <CircleSVG width={size} height={size}>
        <CircleBackground
          cx={size / 2}
          cy={size / 2}
          r={(size - strokeWidth) / 2}
        />
        <CircleProgress
          progress={progress}
          cx={size / 2}
          cy={size / 2}
          r={(size - strokeWidth) / 2}
        />
      </CircleSVG>
    </CircleWrapper>
  );
};

export default CircularProgress;
